<template>
  <div>
    <ul class="faq list-group">
      <li
        class="list-group-item"
        v-for="(item, i) in items"
        :key="item.id"
      >
        <b-btn
          block
          v-b-toggle="'collapse' + i"
          variant="transparent"
        >
          {{ item.title }}
          <div class="icon ml-auto"></div>
        </b-btn>

        <b-collapse
          :id="'collapse' + i"
          accordion="faq-accordion"
          role="tabpanel"
        >
          <div class="collapse-content" v-html="item.content" @click="triggerLinks"></div>
        </b-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Faq",

  computed: {
    faqObject() {
      return this.$store.state.faq;
    },
    items() {
      return this.faqObject.faqItems || [];
    },
  },
  components: {},
  methods: {
    triggerLinks() {
      if (event.target.nodeName == "A" && event.target.target != "_blank") {
        event.preventDefault();
        let to = event.target.href.split(event.target.host);
        this.$router.push(to[1]);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .faq{
    .list-group-item{
      margin-bottom: 16px;
      border: 1px solid #EAEAEA;
      padding: 0;

      .btn{
        font-size: 24px;
        font-weight: 600;
        line-height: 36px;
        letter-spacing: 0em;
        text-align: left;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 0;

        .icon:before{
          content: "+";
          font-size: 28px;
        }

        &[aria-expanded="true"]{
          background-color: #fff;
          .icon:before{
            content: "-";
          }
        }

        &[aria-expanded="false"]{
          .icon:before{
            content: "+";
          }
        }
      }

      .collapse.show, .collapsing{
        background-color: #fff;
      }

      .collapse-content{
        padding: 15px;

        /deep/ p{
          
          font-size: 20px;
          font-weight: 400;
          line-height: 36px;
          letter-spacing: 0em;
          text-align: left;
          color: #000000;
        }
      }
    }
  }
</style>